<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>智慧视频监控系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>智慧视频监控系统</h2>
          <p>视频监控系统是整个安防规划的重点，它是一个分布式的系统，为整个项目提供安全监视、设备监控、管理运维、案发后查、证据提取等有效的技术手段。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'intelligentvideosurveillanceSystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
